import {WixSdk} from 'js-sdk-wrapper';
import {debounce} from '../utils/functions';
import {DEFAULT_VERTICAL_WIDTH} from './constants';
import {layoutValues} from './layout-values';

export function subscribeToExternalEvents({player, initPlayer, isAppOnPageChanged, preventUpdatesChanged}) {
  let wasPlaying;
  const compId = WixSdk.Utils.getCompId();
  WixSdk.PubSub.subscribe('modal.opened', event => {
    if (event.data.openerCompId === compId) {
      WixSdk.PubSub.publish('widget.model-data', player.getModelData());
    }
  });

  WixSdk.addEventListener(WixSdk.Events.EDIT_MODE_CHANGE, () => {
    pausePlayer();
    initPlayer();
  });

  WixSdk.addEventListener(WixSdk.Events.DEVICE_TYPE_CHANGED, () => {
    initPlayer();
    layoutValues[0].width = WixSdk.Utils.getDeviceType() === 'mobile' ? 280 : DEFAULT_VERTICAL_WIDTH;
  });

  WixSdk.addEventListener(WixSdk.Events.PAGE_NAVIGATION, event => {
    const isAppOnPage = event.isAppOnPage;
    isAppOnPageChanged(isAppOnPage);
    if (event.wasAppOnPage) {
      wasPlaying = player && player.isPlaying;
      pausePlayer();
    }
    if (event.isAppOnPage && wasPlaying && player && player.play) {
      player.play();
    }
  });

  WixSdk.addEventListener(WixSdk.Events.SETTINGS_UPDATED, data => {
    if (data === 'album:update' || data === 'control-panel:closed') {
      initPlayer(null, {
        forceUpdate: data === 'album:update'
      });
      return;
    }

    if (data === 'migrationStart') {
      preventUpdatesChanged(true);
      return;
    }
    if (data === 'migrationEnd') {
      location.reload();
      return;
    }

    if (data[0] === 'preview') {
      if (player) {
        player.emit('preview', data[1]);
      }
      return;
    }
    initPlayer();
  });

  WixSdk.addEventListener(WixSdk.Events.STYLE_PARAMS_CHANGE, debounce(data => {
    initPlayer(data);
  }, 100));
  subscribe('playing', pausePlayer, false);

  ['playing', 'pause', 'playbacktoggle', 'prev', 'next', 'shuffle', 'loop'].forEach(eventName => {
    subscribe(`${eventName}.track`, data => {
      player.emit(`${eventName}.track`, data[0]);
    });
  });

  subscribe('timeupdate.track', data => {
    player.emit('timeupdate.track', data[0], data[1]);
  });

  function pausePlayer() {
    if (!player) {
      return;
    }
    if (player.pause) {
      player.pause(); // v2
    } else {
      if (player.playback) { // player.playback is not available on mobile
        player.playback.pause(); //v1
      }
    }
  }

  function subscribe(event, callback, onlyFromCurrentOrigin = true, receivePastEvents = false) {
    // onlyFromCurrentOrigin:true - subscribe only to this origin
    // onlyFromCurrentOrigin:false - subscribe only to other origins
    WixSdk.PubSub.subscribe(event, e => {
      let origin = e.origin;
      let data = e.data;

      if (/\.track$/.test(event)) {
        origin = data[0];
        data = data.slice(1);
      }
      const isEventFromCurrentOrigin = origin === compId;
      if (player && isEventFromCurrentOrigin === onlyFromCurrentOrigin) {
        callback(data);
      }
    }, receivePastEvents);
  }

}





// WEBPACK FOOTER //
// ./widget-player/subscribe-to-external-events.ts